import { observer } from "mobx-react-lite";
import { HelpContact } from 'e.sic-platform.webclient/src/pages/help/components/HelpContact';
import 'e.sic-platform.webclient/src/pages/help/components/composition.scss';

export default observer(function Footer() {
    
    return (
        <HelpContact />
    )
})